import {useRouteLoaderData} from '@remix-run/react'
import type {FunctionComponent} from 'react'
import {Fragment} from 'react'
import clsx from 'clsx'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'
import {getDomainConfig} from '~/domains'
import type {VariationDetails} from './variants-indication'
import {cleanVariation, getPluralEnding} from './variants-indication'

const VariantsIndicationNewLayout: FunctionComponent<VariationDetails> = ({
  index,
  variations,
  reportVariantsClicked,
  ...attributes
}) => {
  const {language, deviceType, locale, domain} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const {styles: stylesBydomain} = getDomainConfig(domain, locale)
  const variantsToDisplay = variations
    ?.slice(0, deviceType !== 'desktop' ? 2 : 3)
    .filter((v) => v?.numberOfVariations > 1)

  return (
    Boolean(variantsToDisplay?.length) && (
      <div {...attributes} onClick={reportVariantsClicked} role="button" tabIndex={0} onKeyDown={() => {}}>
        <p className="flex-shrink-0 cursor-auto text-base font-medium">
          {translations.ProductCard.variantsIndication.title}
        </p>
        {variantsToDisplay?.map((variation, index) => {
          const isPlural = variation.numberOfVariations === 0 || variation.numberOfVariations > 1
          return (
            <Fragment key={`${variation.dimension}-${index}`}>
              <span
                className={clsx(
                  'flex flex-shrink-0 text-base capitalize underline underline-offset-[3px] tablet:text-sm tablet:font-light',
                  stylesBydomain.LISTPAGE_ANCHOR_LINK,
                  'listpage_anchor_link',
                )}
              >{`${variation.numberOfVariations} ${getPluralEnding(cleanVariation(variation.dimension), isPlural)}`}</span>
              {index < variantsToDisplay.length - 1 && ', '}
            </Fragment>
          )
        })}
      </div>
    )
  )
}

export default VariantsIndicationNewLayout
